const features = [
  {
    icon: 'ri-stack-line',
    title: '海量免费资源',
    desc: '收录超过十万部免费漫画，涵盖热血、恋爱、玄幻、悬疑、搞笑等全品类题材，满足各类漫画爱好者的阅读需求。免VIP即可畅读全集，真正实现免费漫画自由。',
  },
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式流畅阅读',
    desc: '采用先进的下拉式阅读技术，无需翻页即可连续阅读，自动预加载后续内容，在桌面端与手机端都能获得丝滑流畅的免费在线漫画阅读体验。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速同步更新',
    desc: '每日同步更新超过三百部热门连载漫画，第一时间推送最新章节，让你不再错过任何追更。热门作品与官方更新节奏保持一致，追更零时差。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          平台优势
        </h2>
        <p className="text-foreground-600 text-sm text-center mb-10 md:mb-14 max-w-xl mx-auto">
          为什么千万读者选择星球漫画
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[1000px] mx-auto">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-2xl p-6 md:p-8 text-center hover:bg-background-200/60 transition-colors"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
                <i className={`${feat.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}